export default __webpack_public_path__ + "Content/Images/content/choose-a-checking-account.jpg";